<template>
  <div class="flex min-h-dvh flex-col items-center gap-4 print:min-h-max">
    <header class="w-full print:hidden">
      <CompanionNavbarLayout />
    </header>
    <CompanionHeaderLayout />
    <main class="container flex grow flex-col print:mx-0 print:min-w-full">
      <RouterView />
    </main>
    <footer class="w-full max-sm:px-3 print:hidden">
      <CompanionFooterLayout />
    </footer>
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import CompanionFooterLayout from './CompanionFooterLayout.vue';
import CompanionHeaderLayout from './CompanionHeaderLayout.vue';
import CompanionNavbarLayout from './CompanionNavbarLayout.vue';
</script>
